<template>
    <v-dialog v-model="dialog" width="800px">
        <v-card>
            <v-card-title class="justify-center">Update a discount code </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                 <v-row no-gutters>  
                    <v-col class="px-2" cols=12>
                        <v-text-field v-model="akcd.akcd_oms" label="Description"></v-text-field>
                    </v-col>  
                </v-row>  
                <v-row no-gutters>
                    <v-col class="px-2" cols=3>
                        <v-text-field v-model="akcd.akcd_verk_kort_bedr" type="number" label="Discount amount" prefix="EUR"></v-text-field>
                    </v-col>  
                    <v-col cols=1>OR
                    </v-col>  
                    <v-col class="px-2" cols=3>
                        <v-text-field v-model="akcd.akcd_verk_kort_perc" type="number" label="Discount percentage" suffix="%"></v-text-field>
                    </v-col>  
                    <v-col class="px-2" cols=3>
                        <v-text-field v-model="akcd.akcd_verk_kort_perc_max_bedrag" type="number" label="Max discount amount" prefix="EUR"></v-text-field>
                    </v-col>    
                </v-row>
                <v-row no-gutters>
                    <v-col class="px-2" cols=4>  
                        <v-select v-model="akcd.akcd_unique_akcc" :items="akcd.akcd_unique_akcc_nrKeuzes" item-value="value" item-text="description" label="Unique discount codes"></v-select>
                    </v-col> 
                </v-row>  
                <v-row no-gutters>
                    <v-col class="px-2" cols=4>  
                        <v-select v-model="akcd.bedr_codes" :items="akcd.bedr_codesKeuzes" multiple item-value="value" item-text="description" label="Accommodation company"></v-select>
                    </v-col>
                    <v-col class="px-2" cols=4>  
                        <v-select v-model="akcd.land_codes" :items="akcd.land_codesKeuzes" multiple item-value="value" item-text="description" label="Accommodation countries"></v-select>
                    </v-col>
                </v-row>   
                <v-row no-gutters>
                    <v-col class="px-2" cols=4>
                        <v-text-field v-model="akcd.akcd_boek_bedrag_min" type="number" label="Booking amount Minimum" prefix="EUR"></v-text-field>
                    </v-col>
                    <v-col class="px-2" cols=4>
                        <v-text-field v-model="akcd.akcd_boek_bedrag_max" type="number" label="Booking amount Maximum" prefix="EUR"></v-text-field>
                    </v-col>    
                </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="primary mx-2" small @click="updAkcd">Save</v-btn>
                <v-btn color="primary"      small @click="dialog = false">Close</v-btn>
            </v-card-actions>
            </v-card>
    </v-dialog>
</template>

<script>
    export default {
        data() { 
            return {
                dialog: false,
                akcd : {},
                akcd_unique_akcc_nrKeuzes: []
            }
        },
        methods: {
            openDialog(akcd_encrid) {
                this.getToUpdAkcdv2(akcd_encrid);
            },
            getToUpdAkcdv2(akcd_encrid) {
                this.$axios.post("ares/json/ares/syst/ref/akcd/getToUpdAkcdv2.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getToUpdAkcdv2"
                    },
                    getToUpdAkcdv2: {
                        akcd_encrid: akcd_encrid,
                    }
                }).then(res => {
                    if (res.data.error) {
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        }); 
                    } else {
                        this.akcd = res.data.getToUpdAkcdv2;
                        this.dialog = true;
                    }
                });
            },
            updAkcd() { 
                this.$axios.post("ares/json/ares/syst/ref/akcd/updAkcdv2.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "updAkcdv2"
                    },
                    updAkcdv2: {
                        akcd_encrid: this.akcd.akcd_encrid,
                        akcd_oms: this.akcd.akcd_oms,
                        akcd_verk_kort_perc : parseFloat(this.akcd.akcd_verk_kort_perc),
                        akcd_verk_kort_bedr : parseFloat(this.akcd.akcd_verk_kort_bedr),
                        akcd_verk_kort_perc_max_bedrag : parseFloat(this.akcd.akcd_verk_kort_perc_max_bedrag),
                        akcd_unique_akcc: this.akcd.akcd_unique_akcc,
                        bedr_codes: this.akcd.bedr_codes,
                        land_codes: this.akcd.land_codes,
                        akcd_boek_bedrag_min : parseFloat(this.akcd.akcd_boek_bedrag_min),
                        akcd_boek_bedrag_max : parseFloat(this.akcd.akcd_boek_bedrag_max)
                    }
                }).then(res => {
                    if (res.data.error) {
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        }); 
                    }  else {
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.updAkcdv2.text,
                            color: res.data.updAkcdv2.color
                        }); 
                        if (res.data.updAkcdv2.color == "success") {
                            this.$emit("refreshList");  
                            this.dialog = false;
                        }
                    }
                });
            },
        }
    }
</script>
